import storage from '@/helpers/storage'
import STORAGE from '@/constants/storage'
import session from '@/helpers/session'
import queryString from '@/helpers/queryString'

// import navigateSchema from '@/constants/navigate-schema'
import bridgeEvent from '@/constants/bridge-event'
import actionType from '@/constants/action-type'
import {mapMutations, mapState} from 'vuex'

export default {
  data () {
    return {
      isTourist: true
    }
  },
  computed: {
    ...mapState('user', ['USERINFO'])
  },
  methods: {
    ...mapMutations('user', ['SET_USER', 'SET_TOKEN', 'SET_USERINFO', 'SET_WXBASESTATE']),
    async getUrlParams () {
      let {token} = queryString.parse(location.search)

      token = session.get(STORAGE.LOGIN_TOKEN) || token || storage.get(STORAGE.LOGIN_TOKEN) || ''
      // let userId = session.get(STORAGE.USERID) || this.urlParse.query.userId || storage.get(STORAGE.USERID) || ''
      // this.SET_USER(userId)
      // this.SET_TOKEN(token)
      // this.bannerId = this.urlParse.query.bannerId || ''
      if (token) {
        storage.set(STORAGE.LOGIN_TOKEN, token)
        session.set(STORAGE.LOGIN_TOKEN, token)
        // await this.getUser()
      } else {
        await this.anonymityLogin()
      }
      // if (this.userId) {
      //   session.set(STORAGE.USERID, this.userId)
      // }
      await this.getUser()
    },
    async anonymityLogin () {
      const data = await this.$authApi.login.anonymityLogin()
      if (data && data.token) {
        session.set(STORAGE.LOGIN_TOKEN, data.token)
        storage.set(STORAGE.LOGIN_TOKEN, data.token)
      }
    },
    async getUser () {
      const {data: {code, data}} = await this.$ultronApi.user.getUser()
      if (code === 0) {
        this.isTourist = data.isTourist
        this.SET_USERINFO(data)
        storage.set(STORAGE.USERINFO, data)
      }
      if (this.isTourist) {
        this.$sa.LOGIN()
      } else {
        this.$sa.LOGIN(data.userId)
        this.$__bl.setConfig({
          uid: data.userId
        })
      }
    },
    async wechatLogin (codeName, isGetUser = true) {
      try {
        let code = queryString.parse(location.search).code
        let res = await this.$authApi.login.wxLogin({
          code,
          distinctId: 'SPERO_APP_H5_DISTINCT_ID'
        })
        console.log('res', res)
        session.set(codeName, code)
        let cb = res.data
        // this.SET_TOKEN(cb.token)
        storage.set(STORAGE.LOGIN_TOKEN, cb.token)
        storage.set(STORAGE.LOGIN_REFRESH, cb.refresh)
        session.set(STORAGE.LOGIN_TOKEN, cb.token)

        isGetUser && await this.getUser()
      } catch (err) {
        console.log('code换取token失败', err)
      }
    },
    toLogin (next, needBindPhone) {
      console.log('toLogin')
      // if (this.os === 'ios') {
      //   storage.set(STORAGE.IS_IN_LOGIN, true)
      //   console.log('tologin start isinlogin', !!storage.get(STORAGE.IS_IN_LOGIN))
      // }
      let self = this
      self.fireEvent(bridgeEvent.action, {
        actionType: actionType.login,
        needBindPhone: needBindPhone || false
      }, async (cb) => {
        console.log('-------login------', cb)

        cb = JSON.parse(cb)
        // self.SET_USER(cb.userId)
        // self.SET_TOKEN(cb.token)
        storage.set(STORAGE.LOGIN_TOKEN, cb.token)
        // storage.set(STORAGE.USERID, cb.userId)
        storage.set(STORAGE.LOGIN_REFRESH, cb.refresh || '')
        session.set(STORAGE.LOGIN_TOKEN, cb.token)
        // console.log(48, cb.userId)
        // session.set(STORAGE.USERID, cb.userId)
        // self.$sa.LOGIN(cb.userId)
        await this.getUser()
        next()
        console.log('tologin callback isinlogin', !!storage.get(STORAGE.IS_IN_LOGIN))
      })
    },
    toBindPhone (next) {
      let self = this
      self.fireEvent(bridgeEvent.action, {
        actionType: actionType.bindPhone
      }, async (cb) => {
        // cb = JSON.parse(cb)
        await this.getUser()
        next()
      })
    },
    async weChatBaseLogin (codeName) {
      try {
        let code = queryString.parse(location.search).code
        let res = await this.$authApi.login.wxSlientAuthLogin({
          code
        })
        console.log('resBase', res)
        session.set(codeName, code)
        let cb = res.data
        if (cb.token) {
          storage.set(STORAGE.LOGIN_TOKEN, cb.token)
          storage.set(STORAGE.LOGIN_REFRESH, cb.refresh)
          session.set(STORAGE.LOGIN_TOKEN, cb.token)
        } else {
          console.log('无token')
          this.SET_WXBASESTATE(true)
          await this.anonymityLogin()
        }
      } catch (err) {
        console.log('code换取token失败', err)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/login.js